import { country } from 'utils/settings';
import { getPrices } from './getPrices';
import { getSkapaPriceProps } from './getSkapaPriceProps';

function initDualCurrency() {
    if (country === 'hr' && window.ikea.dualCurrency === undefined) {
        window.ikea.dualCurrency = {
            getPrices,
            getSkapaPriceProps,
        };
    }
}

export default initDualCurrency;
